import type { WLanguageVersionsTranslations } from "./pl";

export const de: WLanguageVersionsTranslations = {
  empty: "Keine Sprachen konfiguriert.",
  ariaLabel: "Sprachauswahl",
  currentLanguageAria: (name) =>
    `Aktuelle Sprache: ${name}. Zum Ändern klicken.`,
};
